import './comp_map_marker.css'
import React, { useEffect, useRef } from 'react';

export const Comp_Map_Marker = (props) => {
 const mapRef= useRef(null);

 const mapMarkerNew=()=>{
  if (props.qlcList && props.qlcList.length > 0) {
    const mapOptions = {
      center: new window.google.maps.LatLng(22.9764, 76.0555),
      zoom: 4,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP
    };
    const map = new window.google.maps.Map(mapRef.current, mapOptions);
    const infoWindows = [];

    // Function to close all info windows
    const closeAllInfoWindows=()=> {
      //alert(infoWindows.length);
      infoWindows.forEach((infowindow) => infowindow.close());
    }

    props.qlcList.forEach((item) => {
      if(item.gps_lat_log!==""){
        let mapGps=item.gps_lat_log.split(',');
        if(mapGps.length===2){
          let vLat = parseFloat(mapGps[0]);
          let vLng = parseFloat(mapGps[1]);
        
          let iconMarks='http://maps.google.com/mapfiles/ms/icons/green-dot.png';
          if(item.oil_change_status==="Not Active"){
            iconMarks='http://maps.google.com/mapfiles/ms/icons/red-dot.png';
          }
      
      const marker = new window.google.maps.Marker({
        position: { lat: vLat, lng: vLng },
        map: map,
        title: item.name,
        icon: iconMarks
      });

    

      const infoWindow = new window.google.maps.InfoWindow({
        content: `<div class="info-window">
                    <div class="student-name"><strong>Name: </strong>${item.business_name}</div>
                    <div class="student-details"><strong>ID:</strong> ${item.dealer_code}</div>
                    <div class="student-details"><strong>Address: </strong>${item.address+", "+item.city_name+", "+item.pincode+", "+item.state_name}</div>
                    <div class="student-details"><strong>Last Activity: </strong>${item.fmt_last_oil_change}</div>
                    <div class="student-details"><strong>Status: </strong><span class="badge rounded-pill bg-${item.oil_change_status === 'Not Active' ? 'danger' : 'success'}">${item.oil_change_status}</span></div>
                    <div class="student-details"><strong>Workshop: </strong><a href="${"../workshops_performance/"+btoa(item.id)}">${"View Details"}</a></div>

                  </div>`
      });
      infoWindows.push(infoWindow);
     

      marker.addListener('click', () => {
        //alert(infoWindows.length);
        closeAllInfoWindows(); // Close others
        infoWindow.open(map, marker);
       
      });
      
    }//condition for accurate GPS

    }//condition for blank gps

    });
  }
   
 }

 useEffect(()=>{
  

  //markMap();
if(props.qlcList.length>0){
  
  mapMarkerNew();
}
//alert(props.qlcList.length);
//mapMarkerNew();

 },[props.qlcList]);

  return (
    <div style={{"width":"100%"}} class="map-div" ref={mapRef} ></div>
  );
};

export default Comp_Map_Marker;
